import { TextField } from "@mui/material";
import { useStyles } from "./styles";
import { IframeProps } from "./types";

export const Iframe = (props: IframeProps) => {
  const { url, classes: propClasses } = props;
  const { classes } = useStyles({ classesOverrides: propClasses });

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <TextField
        classes={{ root: classes.textField }}
          disabled
          value={url}
          size="small"
          variant="standard"
        />
      </div>
      <iframe className={classes.iframe} src={url} />
    </div>
  );
};
